export default __webpack_public_path__ + "static/media/chair.d02357cf.png";